import React from 'react'
import Shipping from './Shipping'
import { connect } from 'react-redux'
import { actions } from './.'
import { getShipping } from './reducer'

const mapStateToProps = state => ({
  ...getShipping(state),
  onlyCash: state.onlyCash
})

const mapDispatchToProps = dispatch => ({
  fetchShipping: (code, productSkuId) =>
    dispatch(actions.fetchShipping(code, productSkuId)),
  backStateShipping: () => dispatch(actions.backStateShipping()),
  errorFilledShipping: () => dispatch(actions.errorFilledShipping())
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(props => <Shipping {...props} />)



// WEBPACK FOOTER //
// ./src/Catalog/Product/ProductDetail/RedemptionSection/Shipping/ShippingContainer.js